var render = function render(_c,_vm){return _c('div',[(_vm.props.rowValue > 0)?_c('a',{class:[_vm.$options.ColorRegistrosConErrores(_vm.props, _vm.props.column)],attrs:{"href":"#"},on:{"click":function($event){return _vm.$options.show(_vm.props)}}},[_vm._v(" "+_vm._s(_vm.props.rowValue)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }